import { combineReducers } from 'redux';
import conversation from './conversation';
import inbox from './inbox';
import voice from './voice';
import clientInbox from './clientInbox';
import marketing from './marketing';
import emailSettings from './emailSettings';
import draftMessages from './draftMessages';
import chat from './chat';

const appReducer = combineReducers({
  conversation,
  inbox,
  voice,
  clientInbox,
  marketing,
  emailSettings,
  draftMessages,
  chat,
});

export default (state, action) => appReducer(state, action);
